import AssistantCreationTemplate from "./AssistantCreationTemplate";
import PersonSelect from "./PersonSelect";
import { Grid } from "@mui/material";
import Component from "components/Component";
import Disabled from "components/common/Disabled";
import * as labels from "config.labels";
import { useSelector, useDispatch } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as peopleActions from "store/actions/people/peopleActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as peopleSelectors from "store/selectors/people/peopleSelectors";

const AssistantCreation = ({ onCreate, onClose }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const { data: assistants } = staticDataService.useListAssistantsQuery();
  const [createAssistant] = staticDataService.useCreateAssistantMutation();

  return (
    <AssistantCreationTemplate
      assistants={assistants}
      createAssistant={createAssistant}
      visibilityBaseTag={"<AssistantCreation>"}
      formId={"assistant-creation-form"}
      title={translateLabel(labels.ASSISTANT_CREATE_TITLE, {
        default: "Add a new assistant",
      })}
      onCreate={onCreate}
      onClose={onClose}
    />
  );
};

const Assistant = () => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const {
    data: assistants,
    refetch: refreshAssistants,
  } = staticDataService.useListAssistantsQuery();

  const dispatch = useDispatch();
  const assistant = useSelector(peopleSelectors.selectAssistant);

  const updateAssistant = (value) => {
    dispatch(peopleActions.updateAssistant(value));
  };

  const sortedAssistants = [...(assistants ?? [])].sort(
    (a, b) =>
      (a.company || "z").localeCompare(b.company || "z") ||
      (a.name || "z").localeCompare(b.name || "z")
  );

  return (
    <Component
      title={translateLabel(labels.ASSISTANT_TITLE, {
        default: "Assistant",
      })}
      subtitle={translateLabel(labels.ASSISTANT_SUBTITLE, {
        default: "The assistant associated with this submission.",
      })}
    >
      <Disabled ifReadOnly>
        <Grid container direction={"column"} spacing={3}>
          <Grid item xs={12}>
            <PersonSelect
              label={translateLabel(labels.ASSISTANT_TITLE, {
                default: "Assistant",
              })}
              person={assistant}
              personList={sortedAssistants}
              onUpdatePerson={updateAssistant}
              onUpdatePersonList={refreshAssistants}
              PersonCreationComponent={AssistantCreation}
              createNewLabel={translateLabel(labels.ADD_NEW_ASSISTANT, {
                default: "Add new assistant",
              })}
            />
          </Grid>
        </Grid>
      </Disabled>
    </Component>
  );
};

export default Assistant;
